import React, { Component } from 'react';
import Wrapper from '../common/Wrapper';
import RoomsAndStudents from '../RoomsAndStudents';
import { MenuItem} from 'react-bootstrap'
import history from '../../history';
import PropTypes from 'prop-types'
import { routesUrls } from '../../settings/routes';
import Sliders from '../Sliders/Sliders';

class CustomItems extends Component {
  static contextTypes = {formatMessage: PropTypes.any}
  render() {
    const {formatMessage} = this.context;
    return <React.Fragment>
      <MenuItem
        onClick={() => {
          history.push(routesUrls.dashboard)
        }}
      >{formatMessage('navTitleDashboard')}</MenuItem>
   </React.Fragment>
  }
}

const SlidersPage = () => {
  return <Wrapper 
    renderButtonNav = {false}
    CustomItems={CustomItems}
  >
    <Sliders />
  </Wrapper>
}

export default SlidersPage;



// WEBPACK FOOTER //
// ./yii2/frontend/frontend-assets/src/components/routes/SlidersPage.js